import { createSelector } from 'reselect';

import { WORKFLOW_ID as FINANCIAL_ACCOUNTS_WORKFLOW_ID } from '../FinancialAccountsWorkflow/FinancialAccountsWorkflowConstants';
import { WORKFLOW_ID as RETIREMENT_WORKFLOW_ID } from '../RetirementWorkflow/RetirementWorkflowConstants';
import { WORKFLOW_ID as EDUCATION_WORKFLOW_ID } from '../EducationWorkflow/EducationWorkflowConstants';
import { WORKFLOW_ID as HOME_PURCHASE_WORKFLOW_ID } from '../HomePurchaseWorkflow/HomePurchaseWorkflowConstants';
import { WORKFLOW_ID as DEBT_MANAGEMENT_WORKFLOW_ID } from '../DebtManagementWorkflow/DebtManagementWorkflowConstants';
import { WORKFLOW_ID as EMERGENCY_FUND_WORKFLOW_ID } from '../EmergencyFundWorkflow/EmergencyFundWorkflowConstants';
import { WORKFLOW_ID as LARGE_PURCHASE_WORKFLOW_ID } from '../LargePurchaseWorkflow/LargePurchaseWorkflowConstants';
import { WORKFLOW_ID as HEALTHCARE_WORKFLOW_ID } from '../HealthcareWorkflow/HealthcareWorkflowConstants';
import { WORKFLOW_ID as DECUMULATION_WORKFLOW_ID } from '../DecumulationWorkflow/DecumulationWorkflow.constants';

import RETIREMENT_WORKFLOW_DICTIONARY from './SummaryRetirement/SummaryRetirementDictionary';
import EDUCATION_WORKFLOW_DICTIONARY from './SummaryEducation/SummaryEducationDictionary';
import HOME_PURCHASE_WORKFLOW_DICTIONARY from './SummaryHomePurchase/SummaryHomePurchaseDictionary';
import DEBT_MANAGEMENT_WORKFLOW_DICTIONARY from './SummaryDebtManagement/SummaryDebtManagementDictionary';
import EMERGENCY_FUND_WORKFLOW_DICTIONARY from './SummaryEmergencyFund/SummaryEmergencyFundDictionary';
import LARGE_PURCHASE_WORKFLOW_DICTIONARY from './SummaryLargePurchase/SummaryLargePurchaseDictionary';
import HEALTHCARE_WORKFLOW_DICTIONARY from './SummaryHealthcare/SummaryHealthcareDictionary';
import DECUMULATION_WORKFLOW_DICTIONARY, {
  brinkerDictionary,
} from './SummaryDecumulation/SummaryDecumulationDictionary';
import { selectFeatureFlags } from '../../CommonSelectors/CommonAreaSelector';
import { isFeatureEnabled } from '../../_hooks/useFeatureFlag';
import { workflowSubdivision as selectWorkflowSubdivision } from '../AdvWorkflow/AdvWorkflowSelector';

const dictionarySelector = createSelector(
  (state, ownProps) => {
    const { workflowId } = ownProps;

    const isDecumulationFeatureFlag = isFeatureEnabled(
      'DecumulationProposalAccountWf',
      selectFeatureFlags(state),
    );

    const {
      data: { DecumulationProposalAccountName },
    } = selectWorkflowSubdivision(state, ownProps);

    return {
      workflowId,
      isDecumulationFeatureFlag,
      decumulationProposalAccountName: DecumulationProposalAccountName,
    };
  },
  ({ workflowId, isDecumulationFeatureFlag, decumulationProposalAccountName }) => {
    switch (workflowId) {
      case RETIREMENT_WORKFLOW_ID:
        return RETIREMENT_WORKFLOW_DICTIONARY;
      case EDUCATION_WORKFLOW_ID:
        return EDUCATION_WORKFLOW_DICTIONARY;
      case DEBT_MANAGEMENT_WORKFLOW_ID:
        return DEBT_MANAGEMENT_WORKFLOW_DICTIONARY;
      case LARGE_PURCHASE_WORKFLOW_ID:
        return LARGE_PURCHASE_WORKFLOW_DICTIONARY;
      case HOME_PURCHASE_WORKFLOW_ID:
        return HOME_PURCHASE_WORKFLOW_DICTIONARY;
      case EMERGENCY_FUND_WORKFLOW_ID:
        return EMERGENCY_FUND_WORKFLOW_DICTIONARY;
      case HEALTHCARE_WORKFLOW_ID:
        return HEALTHCARE_WORKFLOW_DICTIONARY;
      case DECUMULATION_WORKFLOW_ID: {
        if (isDecumulationFeatureFlag) {
          return brinkerDictionary(decumulationProposalAccountName);
        }

        return DECUMULATION_WORKFLOW_DICTIONARY;
      }
      case FINANCIAL_ACCOUNTS_WORKFLOW_ID:
        return {};
      default:
    }
    return {};
  },
);

export default dictionarySelector;
